import {tokens} from '@pleo-io/telescope'
import VisuallyHidden from '@reach/visually-hidden'
import React from 'react'
import styled from 'styled-components'

import starIcon from '@/images/icons/star.svg'
import {colors} from '@helios/shared/theme'

const MAX_STARS = 5
const STAR_WIDTH = tokens.spacing16
const STAR_GAP = tokens.spacing8

const getCoverPercentage = (index: number, rating: number) => {
    const flooredRating = Math.floor(rating)

    if (index === flooredRating) {
        return `${(1 - (rating - flooredRating)) * 100}%`
    }

    return index < flooredRating ? '0%' : '100%'
}

interface Props {
    numberOfStars: number
}

const Stars = ({numberOfStars}: Props) => (
    <StarsWrapper>
        <VisuallyHidden>{`${numberOfStars} star rating`}</VisuallyHidden>
        {[...Array(MAX_STARS)].map((_, i) => (
            <StarWithPercentage
                $percentage={getCoverPercentage(i, numberOfStars)}
                key={`star-rating-${i}`}
            />
        ))}
    </StarsWrapper>
)

type StarType = {
    $percentage: string
}

const Star = styled.span`
    position: relative;
    background-image: url(${starIcon});
    aspect-ratio: 1;

    :after {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        content: '';
        background: ${colors.overlay.light};
    }
`

const StarWithPercentage = styled(Star)<StarType>`
    :after {
        width: ${(props) => props.$percentage};
    }
`

const StarsWrapper = styled.div`
    position: relative;
    display: grid;
    width: 100%;
    max-width: calc(${MAX_STARS} * ${STAR_WIDTH} + ${MAX_STARS - 1} * ${STAR_GAP});
    grid-auto-flow: column;
    grid-gap: ${STAR_GAP};
`

export default Stars
